// @flow weak
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
  Button,
  Col,
  PanelContainer,
  PanelHeader,
  Grid,
  Panel,
  PanelBody,
  Row,
} from '@sketchpixy/rubix'
import {PatientActions}  from '../reducers/patient/index'

class DisabilityConfirm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      patient: props.location.state
    }
    //console.log("================> "+ JSON.stringify(this.state.patient))
  }

  actions = (link, disbaility) => {
    const {history, location} = this.props
    const patient = JSON.parse(sessionStorage.getItem('patient'));
    this.props.getPatientDoc(patient && patient.id, disbaility.disabilityName)
    history.push({pathname:link, state:disbaility, patient:location.patient})
  }

  goBack = link => {
    const {history, location} = this.props
    console.log(link)
    console.log(location.patient)
    history.push({pathname:link, patient:location.patient})
  }

  componentDidMount() {
    
  }

  getConfirmedDbqIcon = (patient) => {
    return patient && patient.disabilityName ? '/imgs/app/vbg-icons/'+patient.disabilityName.toLowerCase()+'.png' : '';
  }

  render() {
    const {patient = undefined} = this.state
    return (
      <div>
            <Row>
              <Col md={12} className="text-center">
                <h2 className='heading-main'>
                  <strong>Confirm DBQ</strong>
                </h2>
              </Col>
              <Col md={3} >
              
              </Col>
            </Row>
              <Row>
              <Col md={6} smOffset={3}>
                  <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
                      <Panel>
                      <PanelHeader className='bg-custome-red vbg-panel-header' style={{marginBottom: 0}}>
                          <Grid>
                          <Row>
                              <Col md={12} className='fg-white'>
                          
                              </Col>
                          </Row>
                          </Grid>
                      </PanelHeader>
                      <PanelBody className="home-panel-body-user-request-height">
                      <Row className="text-center">
                          <Col md={12}>
                              <div className="text-center" style={{marginTop:50, marginBottom:50}}>
                              <img alt="" src= {this.getConfirmedDbqIcon(patient)} width='100px'/>

                              <h4 style={{marginTop: "13px", marginBottom: "0px"}}>
                                  <strong className="fg-custome-blue font-size25">Patient: {patient && patient.name}</strong>
                              </h4>
                              
                                <div style={{fontWeight: 'bold'}}>
                                  <h1 className="fg-custome-blue" style={{fontWeight: 'bold', textTransform: 'capitalize'}}>{patient && patient.disabilityName && patient.disabilityName}</h1>
                                </div>
                              
                              </div>
                          
                          </Col>
                         
                        </Row>      
                          
                      </PanelBody>
                      </Panel>
                  </PanelContainer>
                  </Col>
              </Row>
              <Row style={{marginBottom: 15}}>
                <Col xs={6} style={{paddingRight: '20px'}} collapseLeft collapseRight className='text-right'>
                    <Button
                        lg
                        type='button'
                        bsStyle='primary'
                        className="bg-custome-none"
                        onClick={this.goBack.bind(this, `/admin/confirmPatient`)}
                    >Back</Button>
                </Col>
                <Col xs={6} style={{paddingLeft: '20px'}} collapseLeft collapseRight
                        className='text-left'>
                    <Button
                        lg
                        type='button'
                        bsStyle='primary'
                        className="bg-custome-blue"
                        onClick={this.actions.bind(this, `/admin/exam`, {name:patient.name, disabilityName:patient.disabilityName})}
                    >Begin Exam</Button>
                </Col>
            </Row>
            
      </div>
    )
  }
}


const mapStateToProps =
  ({ fetching }) => ({
    fetching
  })

const mapDispatchToProps = dispatch => ({
  getPatientDoc: (id, dbq) => {
      dispatch(PatientActions.getSpecificPatientDocumentRequest({
          id,
          dbq
      }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(DisabilityConfirm)
